
import { defineComponent, computed } from 'vue';
import { Form } from 'vee-validate';
import { useProfileStore } from '../../store/profileStore';
import { IEducations } from '@/types/interfaces';
import AppInput from '@/components/UI/AppInput.vue';
import AppDatePicker from '@/components/UI/AppDatePicker.vue';

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppDatePicker,
  },
  setup() {
    const profileStore = useProfileStore();

    function getDefaultEducation(): IEducations {
      return {
        school: '',
        degree: '',
        startDate: null,
        endDate: null,
      };
    }

    function addEducation(): void {
      profileStore.bufferProfile.educations.push(getDefaultEducation());
    }

    if (!profileStore.bufferProfile?.educations?.length) {
      addEducation();
    }

    const isEducationFilled = computed(() => {
      const educations = profileStore.bufferProfile?.educations;
      const lastEducation = educations[educations.length - 1];
      return !!(lastEducation.degree && lastEducation.school && lastEducation.startDate && lastEducation.endDate);
    });

    function disabledStartDateFactory(idx: number): (start: Date) => boolean {
      function getEndDate() {
        return profileStore.bufferProfile.educations[idx]?.endDate;
      }

      function disabledStartDate(start: Date): boolean {
        const endDate = getEndDate();
        return endDate ? start > endDate : false;
      }

      return disabledStartDate;
    }

    function disabledEndDateFactory(idx: number): (start: Date) => boolean {
      function getStartDate() {
        return profileStore.bufferProfile.educations[idx]?.startDate;
      }

      function disabledStartDate(end: Date): boolean {
        const startDate = getStartDate();
        return startDate ? end <= startDate : false;
      }

      return disabledStartDate;
    }

    return {
      profileStore,
      isEducationFilled,
      addEducation,
      disabledStartDateFactory,
      disabledEndDateFactory,
    };
  },
});
